import { computeHypotheticalBonus } from "../lib/discount-bonus.lib";
import { usePublicOrder } from "../queries/use-public-order";
import { usePublicShop } from "../queries/use-public-shop";
import { useDraftReturn } from "./use-draft-return";

/**
 * Bonus the customer would get by taking a store credit on this article, in cents.
 * Returns null when the shop configures no bonus. Used on the resolution cards, where the
 * article is not committed as a store credit yet.
 */
export function useDiscountBonus(
  orderId: string,
  shopId: string,
  lineItemId: string,
): number | null {
  const { data: order } = usePublicOrder(orderId);
  const { data: shop } = usePublicShop(shopId);
  const draft = useDraftReturn(orderId);

  return computeHypotheticalBonus(
    shop,
    order,
    draft?.lineItems ?? [],
    lineItemId,
  );
}
